/* eslint-disable  */
import Vue from 'vue';
import App from './App.vue';
import store from './store';
import touch from './touch-directives'
import router from './router.js'

Vue.config.productionTip = false;

touch.init(Vue)


new Vue({
  store,
  router,
  render: h => h(App),
  mounted () {
  }
}).$mount('#app');


window.addEventListener('touchstart', function onFirstTouch() {
  window.USER_IS_TOUCHING = true
}, false);





// xcode app integration
window.pickerTarget = 'foreground'

window.colorPickedFromOs = (color) => {
  console.log('# colorPickedFromOs', color, window.pickerTarget)
  store.commit('setColor', {
    target: window.pickerTarget,
    value: '#' + color,
    mode: 'hex'
  })
  Vue.forceUpdate()
}
window.osFocus = (value) => {
  console.log('# osFocus', value)
  store.commit('setOsFocus', value )
}
window.osUnFocus = () => {
  console.log('# osUnFocus')
  store.commit('setOsFocus', false )
}
window.getAppStatus = () => {
  if (!window.demoBreak) return 'ALIVE'
  throw "DEMO BREAK"
}

window.demoBreak = false




// to xcode app
if (window.webkit) {
  window.webkit.messageHandlers.jsHandler.postMessage('appBooting');
}




// setTimeout(()=> {
//   document.dispatchEvent(new Event('render-event'))
// }, 1000)

// console.log('boooting desktop app, isElectron:', window.isElectron)

// if (window.isElectron) {
//   window.ipcRenderrer.send('ping', 'hello')
//   window.ipcRenderrer.on('lasse', (event, msg) => console.log('fucking', msg) )
// }
// require('electron').ipcRenderer.on('lasse', (event, message) => {
//   console.log('electro fucking got', message) // Prints 'whoooooooh!'
// })



// console.log('getting global val', require('electron').remote.getGlobal('sharedObject'))